// analytics.ts
type ChosenDeckPayload = {
  deckType: string;
  debug?: boolean;
};

export function trackChosenDeck({ deckType, debug }: ChosenDeckPayload) {
  if (typeof window === "undefined") return;
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push({
    event: "chosen_deck",
    deck_type: deckType,
    // Helps surface in GA4 DebugView even without GTM Preview
    ...(debug ? { debug_mode: true } : {}),
  });
}